<template>
  <input :disabled="disabled"
         ref="input"
         type="number"
         step="any"
         :class="['form-control', ($parent.$parent.hasErrors && !$parent.$parent.isValid) ? 'is-invalid' : '']"
         :value="numericValue"
         placeholder="placeholder"
         @input="inputHandler($event.target.value)" >
</template>

<script>
  export default {
    props: {
      value: [String, Number],
      placeholder: String,

      precision: {
        type: [String, Number],
        default: 0,
      },

      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        numericValue: null,
        handler: Function
      }
    },

    watch: {
      value: {
        immediate: true,
        handler(value) {
          let newValue = value;

          if (newValue) {
            newValue = this.toPrecision(newValue, this.precision);

            if (newValue !== value) {
              this.$emit('input', newValue);
            }
          }

          this.numericValue = newValue;
        }
      }
    },

    methods: {
      toPrecision(value, precision) {
        const regex = new RegExp("^-?\\d+\\.?\\d{0," + precision + "}"); 
        return value && precision ? value.match(regex)[0] : value
      },

      inputHandler(value) {
        this.updateValue(value);
      },

      updateValue: function (value) {
        const oldValue = this.numericValue;

        value = this.toPrecision(value, this.precision);

        if (value === oldValue) {
          this.$refs.input.value = value;
          return;
        }

        this.numericValue = value;
        this.$emit('input', value);
      },
    },

    beforeDestroy() {
      this.handler = null;
    }
  }
</script>
